import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.slug}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="group block"
    >
      <article className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={comic.coverImage}
            alt={`${comic.title} - 韩国漫画在线阅读`}
            title={`${comic.title} - 韩国漫画`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          {comic.status === 'ongoing' ? (
            <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
              连载中
            </span>
          ) : (
            <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
              已完结
            </span>
          )}
          <div className="absolute bottom-2 right-2 bg-background-950/70 text-background-50 text-xs px-2 py-0.5 rounded-full flex items-center gap-1 whitespace-nowrap">
            <i className="ri-star-fill text-yellow-400 text-xs w-3 h-3 flex items-center justify-center"></i>
            {comic.rating}
          </div>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
          <div className="flex items-center gap-2 mt-2">
            {comic.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="text-xs bg-secondary-100 text-secondary-800 px-1.5 py-0.5 rounded whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </article>
    </Link>
  );
}